const local =  {}

// 本地存储
local.set = function (key, value) {
  window.localStorage.setItem(key, JSON.stringify(value));
};

// 本地获取
local.get = function (key) {
  var obj = window.localStorage.getItem(key);
  if (obj && obj != 'undefined' && obj != 'null') {
    return JSON.parse(obj);
  }
  return '';
};

// 本地清除
local.remove = function (key) {
  if (key) {
    window.localStorage.removeItem(key);
  } else {
    for (var i in arguments) {
      window.localStorage.removeItem(arguments[i]);
    }
  }
};

export default local
